import useWindowSize from "@/hook/useWindowSize";
import {Skeleton} from "@mui/material";
import useMobileDetect from "next-device-detection";

export default function SkeletonTransDetail({itemCount}) {
  const detectMobile = useMobileDetect()
  const scaleRate = detectMobile.isMobile ? 1 : 1;

  const array = Array(itemCount ?? 5).fill(0);
  const keyWidthArray = [50, 40];
  const valueWidthArray = [80, 100, 120];

  return <div className="mt-[12px] mb-[12px] flex flex-col items-center">
    <div className="mb-[24px] flex flex-col items-center">
      <Skeleton className="mb-[12px]" animation="wave" variant="circular" width={50} height={50}/>
      <Skeleton animation="wave" height={16} width={50 / scaleRate}/>
      <Skeleton animation="wave" height={32} width={100}/>
    </div>

    <div className="full-w flex-1 w-full">
      {array.map((item, idx) => {
        const keyWidth = keyWidthArray[(Math.floor(Math.random() * keyWidthArray.length))];
        const valueWidth = valueWidthArray[(Math.floor(Math.random() * valueWidthArray.length))];
        return <div key={idx} className="flex flex-1 py-[8px]">
          <Skeleton animation="wave" height={24} width={keyWidth / scaleRate}/>
          <div className="flex-1"></div>
          <Skeleton className="" animation="wave" height={24} width={valueWidth / scaleRate}/>
        </div>
      })}
    </div>
  </div>;
}